import React, { useEffect } from 'react'
import { Trans, withTranslation, WithTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import { is } from '../../../components/MediaQuery'
import Button from '../../../components/Template/Button'
import Modal, {
  ModalHeader,
  ModalHeaderLabel,
} from '../../../components/Template/Modal'
import { theme } from '../../../theme'
import { Mixpanel } from '../../../utils/Mixpanel'

function DeleteModal({
  open,
  close,
  modalId,
  onDelete,
  eventId,
  closeModal,
  t,
}: IDeleteModalProps & IDeleteModalDispatch & WithTranslation) {
  function deleteEvent() {
    onDelete()
    closeModal(modalId)
  }

  useEffect(() => {
    Mixpanel.track('Reservation Delete Screen View', {
      'Reservation ID': Number(eventId),
    })
  }, [eventId])

  function onClose() {
    close(modalId)
  }

  const isDesktop = is.desktop()

  return (
    <Modal
      open={open}
      onClose={onClose}
      deleteModal={true}
      style={{
        marginBottom: isDesktop ? '30vh' : 0,
        maxWidth: isDesktop ? '45em' : '30em',
        minWidth: isDesktop ? '30em' : '10em',
      }}
    >
      <ModalHeader>
        <Flex style={{ fontWeight: 600, width: '100%' }} justifyStart={true}>
          <ModalHeaderLabel>{t('room_confirm_delete_title')}</ModalHeaderLabel>
        </Flex>
      </ModalHeader>

      <div
        style={{
          color: theme.colors.palette.pinkishTan,
          marginTop: '10px',
          overflowWrap: 'break-word',
        }}
      >
        {t('reservation_confirm_delete')}
      </div>
      <Flex row={true} justifyEnd={true} style={{ marginTop: '10px' }}>
        <Button
          outline={true}
          onClick={onClose}
          style={{ marginRight: '25px' }}
        >
          <Trans i18nKey={'cancel'} />
        </Button>
        <Button onClick={deleteEvent} delete={true}>
          <Trans i18nKey={'delete'} />
        </Button>
      </Flex>
    </Modal>
  )
}

export default withTranslation()(DeleteModal)

export interface IDeleteModalProps {
  open?: boolean
  eventId?: any
  modalId?: string
}

export interface IDeleteModalDispatch {
  close: (modalId) => void
  onDelete: () => void
  closeModal?: (modalId) => void
}
